export default __webpack_public_path__ + "static/media/CC_PrimaryLogo_Colour.8e38f849.svg";